"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GatewayTimeoutError = void 0;
const BaseError_1 = require("./BaseError");
/** GatewayTimeoutError reports that an upstream service did not respond in time. */
class GatewayTimeoutError extends BaseError_1.BaseError {
    constructor(description = "Gateway Timeout") {
        super("GatewayTimeoutError", 504, description, true);
    }
}
exports.GatewayTimeoutError = GatewayTimeoutError;
